import Button from "components/CustomButton/CustomButton.jsx";
import Card from "components/Card/Card.jsx";
import React, { useEffect, useState } from "react";
import { Col, Grid, Row, FormControl, Pagination } from "react-bootstrap";
import { getProductList } from "../../../Listfunction";
import ProductListTable from "./ProductListTable";

const ProductList = (props) => {
  const [searchProducts, setsearchProducts] = useState("");
  const [searchSupplier, setsearchSupplier] = useState("");
  const [noRecordFound, setnoRecordFound] = useState(true);
  const [loading, setLoading] = useState(false);
  const [productList, setproductList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();

  useEffect(() => {
    getList();
  }, [searchProducts, searchSupplier]);

  const handlePage = (data) => {
    var token = JSON.parse(localStorage.getItem("user"));
    getProductAllList(token, searchProducts, searchSupplier, data);
  };

  const getList = () => {
    setLoading(true);
    var token = JSON.parse(localStorage.getItem("user"));
    getProductAllList(token, searchProducts, searchSupplier, currentPage);
  };

  const getProductAllList = async (
    token,
    searchProducts,
    searchSupplier,
    currentPage
  ) => {
    const res = await getProductList(
      token,
      searchProducts,
      searchSupplier,
      currentPage
    );
    setproductList(res.data.data);
    setCurrentPage(res.data.current_page);
    setTotalPage(res.data.last_page);
    if (res.data.data.length > 0) {
      setnoRecordFound(false);
    } else {
      setnoRecordFound(true);
    }
    setLoading(false);
  };

  const importProductList = () => {
    props.history.push("/admin/addProductList");
  };
  var token = JSON.parse(localStorage.getItem("user"));
  let active = currentPage;
  let items = [];
  for (let number = 1; number <= totalPage; number++) {
    items.push(
      <Pagination.Item
        onClick={() => {
          handlePage(number);
        }}
        active={number === active}
      >
        {number}
      </Pagination.Item>
    );
  }

  return (
    <div className="main-content">
      <Grid fluid>
        <Row>
          <Col md={12}>
            <Card
              tableFullWidth
              content={
                <>
                  <Row style={{ marginBottom: "10px" }}>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        className="text-right"
                      >
                        <Button onClick={() => importProductList()}>
                          Add Product List <i className="fa fa-plus"></i>
                        </Button>
                        <br />
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className="OrderList_fill"
                      style={{
                        borderRadius: "5px",
                        padding: "10px 20px",
                        width: "97%",
                        margin: "0px auto",
                      }}
                    >
                      <Row>
                        <Col sm={3} xs={12}>
                          <FormControl
                            name="searchProducts"
                            value={searchProducts}
                            placeholder="Search using product details"
                            onChange={(e) => setsearchProducts(e.target.value)}
                            type="text"
                          />
                        </Col>
                        <Col sm={3} xs={12}>
                          <FormControl
                            name="searchSupplier"
                            value={searchSupplier}
                            placeholder="Search using supplier details"
                            onChange={(e) => setsearchSupplier(e.target.value)}
                            type="text"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "20px" }}>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      {productList && (
                        <ProductListTable
                          products={productList}
                          isNotFound={noRecordFound}
                          isLoading={loading}
                        />
                      )}
                    </Col>
                  </Row>
                </>
              }
            ></Card>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Pagination bsSize="medium">{items}</Pagination>
            </div>
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default ProductList;
